import { isEmpty } from 'lodash';
import { hasValue } from "../components/inputs/inputHelpers";

export const getInitials = (fullName = '') => {
  try {
    return fullName.split(' ').map((it) => it[0].toUpperCase()).join('');
  } catch (e) {
    return '';
  }
};

export const dataStrToArray = (str: string | string[]) => {
  if (!str || isEmpty(str)) return [];
  try {
    if (typeof str === 'string') return [str];
    return str;
  } catch (e) {
    return [];
  }
};

export function getRandomStr(max = 16) {
  const letters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let str = '';
  for (let i = 0; i < max; i++) {
    str += letters[Math.floor(Math.random() * max)];
  }
  return str;
}

export function toPascalCase(data: string) {
  return data.match(/[a-z]+/gi)
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase())
    .join(' ');
}

export const trimGuid = (data: string, length: number = 20) => data.substring(0, length);

export function enumToArray(typeData: any) {
  return Object.keys(typeData);
}

// Split pascal case
export function pascalToTitleCase(str: string) {
  return str
    // Look for long acronyms and filter out the last letter
    .replace(/([A-Z]+)([A-Z][a-z])/g, ' $1 $2')
    // Look for lower-case letters followed by upper-case letters
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    // Look for lower-case letters followed by numbers
    .replace(/([a-zA-Z])(\d)/g, '$1 $2')
    .replace(/^./, (newStr) => newStr.toUpperCase())
    // Remove any white space left around the word
    .trim();
}

export function formatSmsGateway(gateway: string): string {
  if (gateway === 'SmsLib') return 'SMPP Library';
  if (gateway === 'SmsKannel') return 'SMS Kannel';
  if (gateway === 'EgoSms') return 'Ego SMS';
  return pascalToTitleCase(gateway);
}

export function formatOperator(operator?: string): string {
  if (!operator) return operator;
  if (operator === 'Mtn') return 'MTN';
  return pascalToTitleCase(operator);
}

export function formatMessageStatus(status?: string): string {
  if (!status) return status;
  return pascalToTitleCase(status);
}

export function formatBulkMessageStatus(status?: string): string {
  if (!status) return status;
  return pascalToTitleCase(status);
}



export function toTitleCase(str: string) {
  if (!hasValue(str)) {
    return str;
  }
  const splitStr = str.toLowerCase()
    .split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if the index is larger than splitStr length, as your for loop does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0)
      .toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

export function containsOnlyNumbers(input: string): boolean {
  // Define a regular expression that matches only numbers
  const numberRegex = /^[0-9]+$/;

  // Test the input string against the regular expression
  return numberRegex.test(input);
}

export function isUUID(input: string): boolean {
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return uuidRegex.test(input);
}

export function isMaskedContent(input?: string): boolean {
  if (!input) return false;
  // Check if the string contains a sequence of at least 3 asterisks.
  // This handles both fully masked ("***") and partially masked ("TIMOTHY***") content.
  return /\*{3,}/.test(input);
}


